<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  ticketId: { type: Number, required: true },
  disabled: { type: Boolean, default: false },
  placeholder: { type: String, default: '' },
});

const { t } = useI18n();
const store = useStore();

const content = ref('');
const isSending = ref(false);

const inputPlaceholder = computed(
  () => props.placeholder || t('SUPPORT_TICKETS.INPUT_PLACEHOLDER')
);

const sendReply = async () => {
  const message = content.value.trim();
  if (!message || isSending.value || props.disabled) return;

  isSending.value = true;
  try {
    await store.dispatch('supportTickets/sendSupportTicketMessage', {
      ticketId: props.ticketId,
      content: message,
    });
    content.value = '';
  } finally {
    isSending.value = false;
  }
};

const onKeydown = event => {
  if (props.disabled) return;
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault();
    sendReply();
  }
};
</script>

<template>
  <div
    class="flex items-end gap-2 px-4 py-3 border-t border-n-weak bg-n-solid-2 shrink-0"
  >
    <textarea
      v-model="content"
      rows="2"
      :disabled="disabled"
      class="m-0 flex-1 px-3 py-2 text-sm border rounded-lg resize-none border-n-weak bg-n-solid-1 text-n-slate-12 focus:outline-none focus:ring-2 focus:ring-n-brand max-h-32 disabled:opacity-60 disabled:cursor-not-allowed"
      :placeholder="inputPlaceholder"
      @keydown="onKeydown"
    />
    <NextButton
      :label="t('SUPPORT_TICKETS.SEND')"
      :disabled="disabled || !content.trim() || isSending"
      :is-loading="isSending"
      @click="sendReply"
    />
  </div>
</template>
